import { z } from 'zod';

export const vehicleSchema = z.object({
  id: z.number().min(1),
  name: z.string().min(1),
  vehicleId: z.string().nullable(),
  modifiedOn: z.string(),
});

export const vehiclesSchema = z.array(vehicleSchema);

export type Vehicle = z.infer<typeof vehicleSchema>;
